import styled from '@emotion/styled';
import Box from '@mui/material/Box';

// =============================================================================
// Layout
// =============================================================================

export const CheckoutPageWrapper = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.novus.checkoutPageBg,
  // Bottom clearance so the floating contact FAB never overlaps the last step.
  // Derived from the FAB dimensions via the shared page primitive (~100px),
  // over-clearing the bare footer height it used to read implicitly.
  paddingBottom: theme.mixins.page.fabClearance,
}));

export const CheckoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '30px',
  maxWidth: theme.mixins.page.maxWidth,
  margin: theme.mixins.page.margin,
  padding: theme.mixins.page.padding,
  alignItems: 'flex-start',
  // R14/R16 21c: the two-column → single-column flip re-pins from the legacy 900px
  // literal to the lg-down band (theme.breakpoints.down('lg') = max-width:1024.95px,
  // the Tablet/Mobile side of the novus lg=1025 boundary). At >=1025 the container
  // stays flex-row with the 30px gutter — byte-identical desktop, no >=1025 pixel
  // moved. The column gap drops to 20px in the stacked state.
  //
  // alignItems resets from the desktop `flex-start` to `stretch` here: once the axis
  // flips to a column, `flex-start` is the cross (horizontal) alignment, which lets the
  // Steps column size to its text max-content instead of the page width — it then
  // balloons past the viewport and clips content at <=1024. `stretch` pins both stacked
  // children to the container width so their content wraps. Scoped to lg-down only, so
  // the >=1025 two-column top-alignment is untouched.
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'stretch',
  },
  // Inner page gutter steps down to 20px on the Mobile band only
  // (theme.breakpoints.down('sm') = max-width:480.95px), replacing the legacy
  // '20px 16px' literal. Desktop keeps mixins.page.padding (30px) above.
  [theme.breakpoints.down('sm')]: {
    padding: '20px',
  },
}));

export const SummaryColumn = styled(Box)(({ theme }) => ({
  width: '380px',
  flexShrink: 0,
  // R14/R16 21c: in the single-column state (lg-down) the Order Summary widens to
  // full width and lifts visually to the top via CSS `order` (-1). DOM order stays
  // steps → summary in CheckoutPage, so tab/focus order is untouched (never
  // flex-direction: column-reverse). Re-keyed from the legacy 900px literal to the
  // lg-down band so it tracks the lg=1025 boundary and flips in lock-step with the
  // container. At >=1025 the column stays 380px — byte-identical desktop.
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    order: -1,
  },
}));
